import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as R from 'ramda';
import { FormSignUp } from 'components/forms/form-sign-up/form-sign-up';
import { FormSignIn } from 'components/forms/form-sign-in/form-sign-in';
import { ModalWindow } from 'components/modal-window/modal-window';
import { withModalActions } from 'core/hocs';

import { AUTH_TYPES, MODAL_IDS } from '../../../constants';

import './auth-modal.scss';

export class AuthModalUI extends Component {
  static propTypes = {
    currentModal: PropTypes.shape({
      id: PropTypes.string,
      data: PropTypes.any
    }).isRequired,
  };

  state = {
    activeTab: this.props.currentModal.data,
    isSuccess: false
  };

  componentDidUpdate(prevProps) {
    const { currentModal: { data } } = this.props;
    const { currentModal: { data: prevData } } = prevProps;

    if (!R.equals(data, prevData) && data) {
      this.toggleTab(data);
    }
  }

  toggleTab = tab => this.setState({ activeTab: tab });

  onSuccess = val => this.setState({ isSuccess: val });

  render() {
    const { activeTab, isSuccess } = this.state;
    const isSignUp = activeTab === AUTH_TYPES.SIGN_UP;
    const isSignIn = activeTab === AUTH_TYPES.SIGN_IN;

    return (
      <ModalWindow
        id={MODAL_IDS.AUTH}
        coreProps={{ id: MODAL_IDS.AUTH }}
        bodyClassName={classNames({
          'auth-modal-body': !isSuccess,
          'p-md-0': isSignUp && !isSuccess,
        })}
        className={classNames({ 'sign-up-modal': isSignUp && !isSuccess })}
        authType={activeTab}
        fade
      >
        <div className={classNames('modal-form-container', { 'animation-hidden': !isSignUp })}>
          {isSignUp && <FormSignUp onSuccess={this.onSuccess} />}
        </div>
        <div className={classNames('modal-form-container h-100', { 'animation-hidden': !isSignIn })}>
          {isSignIn && <FormSignIn />}
        </div>
      </ModalWindow>
    );
  }
}

export const AuthModal = withModalActions(AuthModalUI);
